import { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { Container } from "react-bootstrap";
import { Skeleton } from "@mui/material";


import { Footer, FooterForm, NavBar, NewButton, Schedule } from '../components';
import { tracking } from "../../../utils/tracking";
import { useResizeImg } from '../../../utils/useResizeImg';
import styles from "./Agenda.module.css";
const DESKTOP_IMG_URL = '../../../../assets/events/etvs23/agenda-banner-desktop.jpg'
const MOBILE_IMG_URL = '../../../../assets/events/etvs23/agenda-banner-mobile.jpg'




export const Agenda = () => {
   document.title = "Emerging Tech Venture Summit | Agenda";

   const [isLoading, setIsLoading] = useState(true);
   const [isScheduleLoding, setIsScheduleLoding] = useState(true);
   const location = useLocation()
   const navigate = useNavigate()
   const imageSource = useResizeImg(DESKTOP_IMG_URL, MOBILE_IMG_URL)

   useEffect(() => {
      (location.pathname === "/agenda") && navigate('/agenda/0')
   }, [location.pathname]);// eslint-disable-line 


   return (
      <>
         <NavBar />
         <Container className={styles.banner} fluid>
            {isLoading ?
               <Skeleton animation="wave" variant="rectangular" sx={{ minHeight: imageSource === DESKTOP_IMG_URL ? '65vh' : '100vh', position: 'initial !important', backgroundColor: '#0F1A28' }}>
                  <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '47.5%' : '40%', top: '40%' }} />
                  <img
                     onLoad={() => { setIsLoading(false); setTimeout(() => setIsScheduleLoding(false), 2000) }}
                     src={imageSource}
                     alt='home-img'
                     style={{ visibility: 'hidden', minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                  />
               </Skeleton>
               :
               <img
                  src={imageSource}
                  loading="eager"
                  alt='home-img'
                  style={{ minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
               />

            }
            {
               !isLoading &&
               <div className={styles.itemsOnImg}>
                  <h2 >Explore Engaging Content</h2>
                  {/* <Link to='/events/etvs23/registration' onClick={() => tracking(290)} className={styles.btn}>
                     <NewButton name='GET YOUR TICKET' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </Link> */}
                  <a href="https://youngstartup.com/upcoming" onClick={() => tracking(290)} className={styles.btn}>
                     <NewButton name='GET YOUR TICKET' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </a>
               </div>
            }
         </Container>
         {isScheduleLoding &&
            <div style={{ height: '50vh', position: 'relative' }}>
               <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '47.5%' : '40%', top: '20%' }} />
            </div>
         }
         <Routes>
            <Route path=':day' element={<Schedule />} />
         </Routes>

         <FooterForm />
         <Footer />
      </ >
   );
};
